import { render, staticRenderFns } from "./LayoutEditor.vue?vue&type=template&id=4d5a60f2&"
import script from "./LayoutEditor.vue?vue&type=script&lang=js&"
export * from "./LayoutEditor.vue?vue&type=script&lang=js&"
import style0 from "./LayoutEditor.vue?vue&type=style&index=0&id=4d5a60f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports